import { DateTime } from 'luxon'

export function formatDate(date: string, format: string) {
  return DateTime.fromISO(date).toFormat(format)
}

export const secondsDiff = (serverTime: Date, clientTime: Date, saleEndDate: Date) => {
  const adjustTime = serverTime.getTime() + (new Date().getTime() - clientTime.getTime())
  return Math.round((saleEndDate.getTime() - adjustTime) / 1000)
}

export const getNextDate = (day): Date => {
  var nextdate = new Date(day)
  return new Date(nextdate.setDate(nextdate.getDate() + 1))
}

export const addMonths = (date: Date, months: number) => {
  const newDate = new Date(date)
  newDate.setMonth(newDate.getMonth() + months)
  return newDate
}

export const addDays = (date: Date, days: number) => {
  const newDate = new Date(date)
  newDate.setDate(newDate.getDate() + days)
  return newDate
}

// export const getVendorTime = (date: Date, timeZoneRegistryID) => {
//   const timeZone = findIana(timeZoneRegistryID)?.[0]
//   return new Date(
//     date.toLocaleString('en-US', {
//       timeZone
//     })
//   )
// }
